const Grid = {
  defaultProps: {
    gutter: 'md',
    columns: 12,
  },
};

export default Grid;
